export const FRONT_LOOKUP_CONFIG = {
    // Min characters before a prediction is attempted (e.g. "W25").
    memberIdPayerPredictionMinLength: 3,

    get payerIdCorrectionsMapping(): Record<string, string> {
        return {
            "6111": "06111",
        }
    },
}
